import { Box, Button, Card, CardBody, CardFooter, CardHeader, CheckBox, Image, Paragraph, Text } from "grommet"
import { SettingsOption } from "grommet-icons"
import { formattedPrice } from "../../utils/priceUtils"
import { useUpdateDonateVariantMutation } from "../../api/donateVariantsApi"
import { addNotification } from "../../slices/notificationsSlice"
import { useDispatch } from "react-redux"
import { Trans, useTranslation } from "react-i18next"

const donateVariantTypes = {
    AUCTION: 'AUCTION',
    ROULETTE: 'ROULETTE',
    MEMES: 'MEMES'
}

const donateVariantCardPreviewImage = {
    AUCTION: `${process.env.REACT_APP_CDN_BASE_URL}/homepage/auc_banner.webp`,
    ROULETTE: `${process.env.REACT_APP_CDN_BASE_URL}/homepage/roulette_banner.webp`,
    MEMES: `${process.env.REACT_APP_CDN_BASE_URL}/homepage/memes_banner.webp`
}

export const DonateVariantCard = ({ data, onSettingsClick }) => {

    const dispatch = useDispatch();

    const [updateDonateVariant] = useUpdateDonateVariantMutation();

    const handleDonateVariantEnable = (event) => {
        const value = event.target.checked;
        updateDonateVariant({ ...data, ...{ enabled: value } })
        .unwrap()
        .then(response => {
            dispatch(addNotification({ show: true, message: `Donate variant successfully ${value ? 'enabled' : 'disabled'}.`, status: 'normal' }));
        })
        .catch(error => dispatch(addNotification({ show: true, message: `Unable to ${value ? 'enable' : 'disable'} donate variant.`, status: 'critical' })))
    }

    return (
        <Card style={{ maxWidth: '500px' }}>
            <CardHeader pad={'none'}>
                <Box>
                    <Image src={donateVariantCardPreviewImage[data?.type]} />
                </Box>
            </CardHeader>
            <CardBody gap="small">
                <Box direction="row" justify="between">
                    <Text size="medium" weight={'bolder'} truncate="tip" >{data?.title}</Text>
                    <CheckBox toggle pad={'none'} checked={data.enabled} onClick={handleDonateVariantEnable} />
                </Box>
                <Paragraph size="small" margin={'none'} style={{ minHeight: '100px' }}>{data?.description}</Paragraph>
            </CardBody>
            <CardFooter direction="row" justify="between" align="center">
                <Text weight={'bold'}><PriceTitle data={data} /></Text>
                <Button icon={<SettingsOption />} onClick={() => onSettingsClick(data)} />
            </CardFooter>
        </Card>
    )
}

const PriceTitle = ({ data }) => {

    const { t, ready } = useTranslation('donations', { useSuspense: false })

    if (data?.type ===  donateVariantTypes.AUCTION) {
        return (<Trans t={t} i18nKey="fromPrice" values={{ price: formattedPrice(data?.cost) }} />);
    } else if (data?.type === donateVariantTypes.ROULETTE) {
        return (<Trans t={t} i18nKey="spinCost" values={{ price: formattedPrice(data?.cost) }} />);
    } else if (data?.type === donateVariantTypes.MEMES) {
        return (<Trans t={t} i18nKey="fromPrice" values={{ price: formattedPrice(data?.price) }} />);
    }
    return (`${formattedPrice(data?.cost)} UAH`);
}